import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { DirectivesModule } from '../../../directives/directives.module';
import { DisableInputSpinEventsDirective } from '../../../directives/disable-input-spin-events.directive';
import { CustomFormsModule } from '../../custom-forms/custom-forms.module';

@Component({
  selector: 'csl-cut-input',
  templateUrl: './cut-input.component.html',
  standalone: true,
  imports: [
    FlexModule,
    DirectivesModule,
    MatLegacyFormFieldModule,
    NgClass,
    ExtendedModule,
    DisableInputSpinEventsDirective,
    FormsModule,
    MatLegacyInputModule,
    CustomFormsModule,
    NgIf,
  ],
})
export class CutInputComponent implements OnInit {
  _X = 0;
  _Y = 0;

  @Input() editable = true;

  @Input() xMax = 0;
  @Input() xMin = 0;
  @Input() yMax = 0;
  @Input() yMin = 0;

  @Output() xChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set x(value: number) {
    this._X = value;
  }

  @Output() yChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set y(value: number) {
    this._Y = value;
  }

  @Input()
  get dense() {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  constructor() {}

  ngOnInit(): void {}
}
